import { Map } from "immutable";
import buildKeyPathMap from './buildKeyPathMap';

export default function findKeyPathByRowId(statement: Statement, rowId: string): KeyPath|null {
    const keyMap: Map<string, KeyPath> = buildKeyPathMap(statement.rows);
    return keyMap.get(rowId, null);
}
